import { useTranslation } from 'react-i18next';

export const useBooleanStatus = (val: boolean | undefined = false): string => {
  const { t } = useTranslation('common');
  return val ? t('common.yes') : t('common.no');
};
